<template>
  <icon
    v-if="!isLoading"
    :class="[ 'c-icon', { ['-' + icon]: true }]"
    :icon="icon"
    :width="size"
    :height="size"
  />
</template>

<script>
import Icon from 'vue-svgicon'

export default {
  components: { Icon },
  props: {
    size: String,
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  watch: {
    icon (newIcon, oldIcon) {
      if (process.env.NODE_ENV !== 'development' && newIcon !== oldIcon) {
        this.loadIcon()
      }
    }
  },
  methods: {
    loadIcon: async function () {
      this.isLoading = true
      await import('@assets/icons/' + this.icon)
      this.isLoading = false
    }
  },
  mounted () {
    this.loadIcon()
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.c-icon {
  fill: $icon-color;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CIcon.vue